import { z } from 'zod';
import { validationMessagesMap } from 'src/utils/messages';
import { VOUCHER_TYPE_USAGE } from 'src/features/voucherTypes/utils/types';
import { CURRENCY } from 'src/types';

export type VoucherTypeFormSchemaValues = z.infer<typeof voucherTypeFormSchema>;
export const voucherTypeFormSchema = z
    .object({
        name: z.string().nonempty(),
        code: z.string().nonempty(),
        valid_from: z.string().nonempty(),
        valid_to: z.string().optional().nullable(),
        is_active: z.boolean(),
        usage: z.enum(VOUCHER_TYPE_USAGE).nonoptional(),
        description: z.string().optional().nullable(),
        valid_duration: z.string().optional().nullable(),
        max_count: z.number().int().min(0).optional().nullable(),
        amount: z.number().int().min(0).optional().nullable(),
        percent: z
            .string()
            .optional()
            .nullable()
            .refine(
                (val) => {
                    if (!val) return true;
                    const num = Number(val);
                    return !isNaN(num) && num >= 0 && num <= 100;
                },
                {
                    message: validationMessagesMap.validationErrorPercent,
                },
            ),
        currency: z.enum(CURRENCY),
    })
    .superRefine((data, ctx) => {
        if (data.amount && !data.percent) return;
        if (!data.amount && data.percent) return;

        if (!data.amount && !data.percent) {
            ctx.addIssue({
                path: ['percent'],
                message: validationMessagesMap.validationErrorDiscountPolicy,
                code: 'custom',
            });
            ctx.addIssue({
                path: ['amount'],
                message: validationMessagesMap.validationErrorDiscountPolicy,
                code: 'custom',
            });
        }
    });
